import LeftClassify from '../../components/LeftClassify';
import Banner from '../../components/Banner';
import UserCard from '../../components/UserCard';

import './index.less';

export default () => {
  return (
    <div className="top-banner-module">
      <LeftClassify />
      <Banner />
      <UserCard />
    </div>
  );
};
